export default __webpack_public_path__ + "10bd0195f91eb809a823071211971e96.svg";